import axios from "axios";
import { url } from "./url.service";
import { axiosApiInstance } from "../App";

const serverUrl = url + "/Order";

export const getAllOrders = (query) => {
  return axios.get(`${serverUrl}/getAllActiveOrders?${query}`);
};
export const downloadOrderExcelApi = (query) => {
  return axiosApiInstance.get(`${serverUrl}/downloadOrderExcel?${query}`);
};

export const getOrderById = async (id) => {
  return axios.get(`${serverUrl}/getOrderById/${id}`);
};

export const updateOrderById = async (id, obj) => {
  return axiosApiInstance.patch(`${serverUrl}/updateById/${id}`, obj);
};
export const updateStatusOrderById = async (id, obj) => {
  return axios.patch(`${serverUrl}/updateStatusOrderById/${id}`, obj);
};

export const updateStatusProductsInBulk = async (obj) => {
  return axiosApiInstance.patch(`${serverUrl}/updateStatusProductsInBulk`, obj);
};
